import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import React Quill CSS
import { baseUrl } from '../config';
import SEO from '../components/SEO';



const Portfolio = () => {
  return (
    <div className="App">
      <SEO
        title="Filmmaker Portfolio"
        description="Showcase your film portfolio, credits, and work samples to producers and studios worldwide on ProducerBuddy."
        url="https://producerbuddy.pilomation.com/portfolio"
        robots="noindex, nofollow"
      />
      <div className="bg-gray-800 text-white p-6 text-center">
        <img
          src="profile-picture-url.jpg"
          alt="Profile"
          className="w-32 h-32 rounded-full mx-auto mb-4"
        />
        <h1 className="text-4xl font-bold">John Doe</h1>
        <p className="text-lg mt-2">Full Stack Developer | Designer</p>
      </div>

      <main className="p-6">
        {/* About Section */}
        <section className="mb-8">
          <h2 className="text-3xl font-bold mb-4">About Me</h2>
          <p className="text-lg">
            I am a passionate full-stack developer with experience in building modern web applications. I have a strong background in both front-end and back-end technologies, and I enjoy working on projects that challenge my skills and help me grow.
          </p>
        </section>

        {/* Experience Section */}
        <section className="mb-8">
          <h2 className="text-3xl font-bold mb-4">Experience</h2>
          <div className="space-y-4">
            <div className="bg-gray-100 p-4 rounded-lg shadow">
              <h3 className="text-xl font-semibold">Software Engineer at TechCorp</h3>
              <p className="text-sm text-gray-600">Jan 2020 - Present</p>
              <p className="mt-2">
                Developed and maintained web applications, implemented new features, and optimized performance.
              </p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg shadow">
              <h3 className="text-xl font-semibold">Frontend Developer at WebWorks</h3>
              <p className="text-sm text-gray-600">Jun 2018 - Dec 2019</p>
              <p className="mt-2">
                Created responsive web pages and user interfaces, collaborated with designers to bring mockups to life.
              </p>
            </div>
          </div>
        </section>

        {/* Skills Section */}
        <section className="mb-8">
          <h2 className="text-3xl font-bold mb-4">Skills</h2>
          <ul className="list-disc pl-6">
            <li>JavaScript (React, Node.js)</li>
            <li>HTML & CSS (Tailwind CSS, Bootstrap)</li>
            <li>Backend Development (Spring Boot, Express)</li>
            <li>Database Management (PostgreSQL, MongoDB)</li>
            <li>Version Control (Git)</li>
          </ul>
        </section>

        {/* Projects Section */}
        <section className="mb-8">
          <h2 className="text-3xl font-bold mb-4">Projects</h2>
          <div className="space-y-4">
            <div className="bg-gray-100 p-4 rounded-lg shadow">
              <h3 className="text-xl font-semibold">Project Management Tool</h3>
              <p className="text-sm text-gray-600">Developed a tool to manage projects with features like task assignments, progress tracking, and reporting.</p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg shadow">
              <h3 className="text-xl font-semibold">E-commerce Website</h3>
              <p className="text-sm text-gray-600">Built a full-stack e-commerce platform with payment integration and user authentication.</p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="mb-8">
          <h2 className="text-3xl font-bold mb-4">Contact</h2>
          <p className="text-lg mb-4">Feel free to reach out to me via email or connect with me on social media.</p>
          <div className="text-center">
            <p className="text-lg font-semibold">Email: john.doe@example.com</p>
            <div className="flex justify-center space-x-4 mt-4">
              <a href="https://www.facebook.com/login/" target="_blank" rel="noopener noreferrer" className="text-xl">
                Facebook
              </a>
              <a href="https://www.instagram.com/accounts/login/" target="_blank" rel="noopener noreferrer" className="text-xl">
                Instagram
              </a>
              <a href="https://twitter.com/login" target="_blank" rel="noopener noreferrer" className="text-xl">
                Twitter
              </a>
              <a href="https://www.linkedin.com/login" target="_blank" rel="noopener noreferrer" className="text-xl">
                LinkedIn
              </a>
            </div>
          </div>
        </section>

        {/* Blog Section */}
        <section className="mb-8">
          <h2 className="text-3xl font-bold mb-4">Blog</h2>
          <ReactQuill theme='snow' placeholder='Write something...' />
        </section>
      </main>
    </div>
  );
};

export default Portfolio;

